import type { DataGetter } from '@rea-argonaut/analytics';
import { trackEvent } from '@rea-argonaut/analytics';

export interface TrackDisclaimerModalOpen {
  inPageSource: string;
}
export const trackDisclaimerModalOpen = ({ inPageSource }: TrackDisclaimerModalOpen): void => {
  const event: DataGetter = () => ({
    schema: 'iglu:au.com.property/pca_disclaimer_modal_open/jsonschema/1-0-0',
    data: {
      event_name: 'pca_disclaimer_modal_open',
      in_page_source: inPageSource,
    },
  });
  trackEvent(event);
};
